import { useModal } from 'components/modals/useModal';
import { useCallback } from 'react';
import { MatterDto } from 'types/matters';
import { CloseCaseModal } from './CloseCaseModal';

interface OpenCloseCaseModalArgs {
    matterId: number;
    onClosed?: (matter: MatterDto) => void;
}

const CLOSE_CASE_MODAL_STYLE = { width: 640 };

export function useCloseCaseModal(): { openCloseCaseModal: (args: OpenCloseCaseModalArgs) => void } {
    const { openModal, closeModal } = useModal();

    const openCloseCaseModal = useCallback(
        ({ matterId, onClosed }: OpenCloseCaseModalArgs) => {
            openModal(
                <CloseCaseModal
                    matterId={matterId}
                    onCancel={closeModal}
                    onClosed={(matter) => {
                        closeModal();
                        onClosed?.(matter);
                    }}
                />,
                closeModal,
                CLOSE_CASE_MODAL_STYLE
            );
        },
        [openModal, closeModal]
    );

    return { openCloseCaseModal };
}
